import { Controller } from "@hotwired/stimulus"

// Adapts Chartkick/Chart.js colors to the current light/dark theme.
// Attach to a wrapper element around a Chartkick chart.
export default class extends Controller {
  static values = { chartId: String }

  connect() {
    this._observer = new MutationObserver(() => this._applyTheme())
    this._observer.observe(document.documentElement, { attributes: true, attributeFilter: ["data-mode"] })

    // Chartkick loads via deferred script — poll until chart is ready
    this._waitForChart()
  }

  disconnect() {
    this._observer?.disconnect()
    clearTimeout(this._pollTimer)
  }

  _waitForChart(attempts = 0) {
    const chart = window.Chartkick?.charts?.[this.chartIdValue]
    if (chart?.getChartObject()) {
      this._applyTheme()
      return
    }
    if (attempts < 20) {
      this._pollTimer = setTimeout(() => this._waitForChart(attempts + 1), 150)
    }
  }

  _applyTheme() {
    const dark = document.documentElement.getAttribute("data-mode") === "dark"
    const chart = window.Chartkick?.charts?.[this.chartIdValue]
    if (!chart) return

    const cjs = chart.getChartObject()
    if (!cjs) return

    const barColor = dark ? "#e5e7eb" : "#111827"
    const gridColor = dark ? "rgba(255,255,255,0.07)" : "rgba(0,0,0,0.06)"
    const tickColor = dark ? "#9ca3af" : "#6b7280"

    // Update bar colors
    cjs.data.datasets.forEach((ds) => {
      ds.backgroundColor = barColor
    })

    // Update scales
    if (cjs.options.scales?.y) {
      cjs.options.scales.y.grid.color = gridColor
      cjs.options.scales.y.ticks = { ...cjs.options.scales.y.ticks, color: tickColor }
    }
    if (cjs.options.scales?.x) {
      cjs.options.scales.x.ticks = { ...cjs.options.scales.x.ticks, color: tickColor }
    }

    cjs.update("none")
  }
}
